/**
 * Labstep
 *
 * @module components/ProtocolValue/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { IProtocolValueActionDeleteProps } from './types';

export const ProtocolValueActionDelete: React.FC<
  IProtocolValueActionDeleteProps
> = ({ protocolValue, ...rest }) => (
  <EntityActionDelete
    dataCy="components/ProtocolValue/Action/Delete"
    {...rest}
    entity={protocolValue}
  />
);
